import React, { useState, useEffect, useCallback } from 'react';

export default function answerTracker({ form, meta }) {
  const [formAnswers, setFormAnswers] = useState({});

  const [localAnswers, setLocalAnswers] = useState({});

  useEffect(() => {
    let answers = {...formAnswers} || {};

    if (!form || !meta?.ready) {
      return;
    }

    form?.template?.pages?.forEach((page, pageIndex) => {
      page?.custom_fields?.forEach((field, fieldIndex) => {
        if(field.mapped_name) {
          answers[field.mapped_name] = field.value || '';
        }
      });
    });

    setFormAnswers(answers);
  }, [meta.ready]);

  const getFieldValue = useCallback((mappedName) => {
    if(localAnswers && localAnswers.hasOwnProperty(mappedName)) {
      return localAnswers[mappedName];
    }

    if(formAnswers && formAnswers.hasOwnProperty(mappedName)) {
      return formAnswers[mappedName];
    }

    return undefined;
  }, [localAnswers, formAnswers]);

  const getNormalizedFieldValue = useCallback(
    (mappedName) => CustomForm.sanitizeValue(getFieldValue(mappedName)),
    [localAnswers, formAnswers]
  );

  const setFieldValue = useCallback((mappedName, value) => {
    const newAnswers = {
      ...localAnswers,
      [mappedName]: value
    };
    setLocalAnswers(newAnswers);
  }, [localAnswers]);


  const useDependency = (field) => {
    const [met, setMet] = useState(field.dependent_yes);

    useEffect(() => {
      if (!field.dependencies || field.dependencies.length == 0) {
        setMet(true);
        return;
      }

      setMet(
        field.dependencies.every(dep => {
          const value = getNormalizedFieldValue(dep.mapped_name);
          const matched = dep.normalized_trigger_values.includes(value);

          return matched;
        })
      );
    }, [field.dependencies, formAnswers, localAnswers]);

    return met;
  };

  return {
    getFieldValue,
    setFieldValue,
    useDependency
  };
}
